var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app-bar',{staticClass:"pa-0 breakdance-topbar d-flex flex-row",attrs:{"short":"","color":"var(--white)","height":"auto","width":"100%","flat":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }